import { useNavigate } from 'react-router-dom';
import {
  AspectRatio,
  BackgroundImage,
  ButtonMantine,
  DEFAULT_BRAND_IMAGE,
  Flex,
  Skeleton,
} from 'ui';
import { IconChevronLeft } from 'ui/Icons';

import classes from './CausePageLayout.module.css';

type Props = {
  isLoading: boolean;
  src?: string;
  children?: React.ReactNode;
  headerButtons?: JSX.Element | JSX.Element[];
  backTo?: string;
};

export const HeaderImage = ({ isLoading, src, children, headerButtons, backTo }: Props) => {
  const navigate = useNavigate();

  return (
    <>
      <Skeleton visible={isLoading}>
        <BackgroundImage className={classes.imageHeader} src={src ?? DEFAULT_BRAND_IMAGE}>
          <AspectRatio ratio={2 / 1}>
            <Flex direction={'column'} justify="space-between" w="100%" p={'md'}>
              <Flex w="100%" justify="space-between">
                <ButtonMantine
                  size="sm"
                  leftSection={<IconChevronLeft />}
                  variant="white"
                  color="gray"
                  onClick={() => navigate(backTo ?? '..')}
                >
                  Back
                </ButtonMantine>
                <Flex gap="sm">{headerButtons}</Flex>
              </Flex>
              {children}
            </Flex>
          </AspectRatio>
        </BackgroundImage>
      </Skeleton>
    </>
  );
};
